<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <el-select
              class="select-default mb-3"
              style="width: 100%"
              v-model="filter_departments"
              collapse-tags
              filterable
              placeholder="Departamentos"
              @change="cleanSelect"
              multiple>
              <el-option
                class="select-default"
                v-for="item in departments"
                :key="item.CodeDpto"
                :label="item.NameDpto"
                :value="item.CodeDpto">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <el-select
              class="select-default mb-3"
              style="width: 100%"
              multiple
              filterable
              placeholder="Municipios"
              collapse-tags
              v-model="filter_municipalities">
              <el-option
                class="select-default"
                v-for="item in municipalities"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <el-date-picker
              style="width: 100%"
              :clearable="false"
              v-model="rangeDate"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="-"
              start-placeholder="Fecha Inicial"
              end-placeholder="Fecha Final"
              align="center">
            </el-date-picker>
          </div>
          <div class="col-12 col-md-6 col-lg-3 text-center">
              <br class="c-none">
              <button type="button" class="btn btn-warning" @click="getFilteredData">Filtrar Datos</button>
          </div>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div v-if="canIndex()">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-6">
                <el-select
                  class="select-default mb-3"
                  v-model="pagination.perPage"
                  placeholder="Por pagina">
                  <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <div class="mr-1 pull-right" v-if="canPDF()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/pdf.svg"
                    alt="pdf"
                    v-tooltip="'Exportar en formato PDF'"
                    @click="exportPDF('Soportes_Facturación', 'Soportes de Facturación', 'a2', tableData, tableColumnsAll, 1)">
                </div>
                <div class="mr-1 pull-right" v-if="canExcel()">
                    <img
                      class="img-exports"
                      src="/static/img/icons/docs/xls.svg"
                      alt="xls"
                      v-tooltip="'Exportar en formato XLSX'"
                      @click="exportExcel('Soportes_Facturación', tableData, tableColumnsAll, 1)">
                </div>
                <div class="mr-1 pull-right" v-if="canCSV()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/csv.svg"
                    alt="csv"
                    v-tooltip="'Exportar en formato CSV'"
                    @click="exportCSV('Soportes_Facturación', tableData, tableColumnsAll, 1)">
                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <el-input
                class="mb-3"
                placeholder="Buscar registros"
                v-model="searchQuery"
                aria-controls="datatables"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      @selection-change="handleSelectionChange"
                      border
                      ref="tableModule">
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
              <el-table-column
                fixed="right"
                type="selection"
                width="55">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-3">
      <div class="text-center">
        <button class="btn btn-danger btn-fg custom-shadow-btn" @click="exportPDF('Soportes_facturacion', 'Soportes de Facturación', 'a2', tableData, tableColumnsAll, 1)"><i class="fa fa-file-pdf-o"></i>
            Exportar a PDF
        </button>
      </div>
    </div>
    <div class="col-3">
      <div class="text-center">
        <button oncli class="btn btn-success btn-fg custom-shadow-btn" @click="exportExcel('Soportes_facturacion', tableData, tableColumnsAll, 1)"><i class="fa fa-file-excel-o"></i>
        Exportar a Excel
      </button>
      </div>
    </div>
    <div class="col-3">
      <div class="text-center">
        <button class="btn btn-info btn-fg custom-shadow-btn" @click="exportCSV('Soportes_facturacion', tableData, tableColumnsAll, 1)"><i class="fa fa-file-text-o"></i>
          Exportar a CSV
        </button>
      </div>
    </div>
    <div class="col-3">
      <div class="text-center">
        <button v-bind:disabled="multipleSelection.length == 0" @click="dowloadSuports()" class="btn btn-secondary btn-fg custom-shadow-btn"><i class="fa fa-download"></i>
          Descargar Facturas
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <el-dialog v-if="canShow()"
      :title="title"
      :visible.sync="modals.read">
        <p>A continuación encontrarás toda la información asociada al registro seleccionado.</p>
        <div class="card" v-if="rowData">
          <div class="card-body">
            <table class="table">
              <tbody v-if="rowData">
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Región:</b></h6>
                      {{rowData.Region}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Departamento:</b></h6>
                      {{rowData.Depart_Nombre}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Municipio:</b></h6>
                      {{rowData.Municipio_Nombre}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>ID Punto:</b></h6>
                      {{rowData.IDPunto}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Cédula:</b></h6>
                      {{rowData.NumeroDoc}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Cliente:</b></h6>
                      {{rowData.Nombres}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Fecha Contabilización:</b></h6>
                      {{rowData.FechaContabilizacion}}
                    </td>
                  </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import MixinDatePicker from "src/util/mixinDatePicker"
  import showSwalAlert from 'src/util/alerts'
  import swal from 'sweetalert2'
  import axios from 'axios'
  import moment from 'moment'
  import table from './billingSupportsTable'
  import store from '@/store'

  export default {
    data () {
      return {
        demandsForm: {},
        departments: [],
        municipalities: [],
        multipleSelection: [],
        tableColumns: table[0],
        tableColumnsAll: table,
        isShow: true,
        rangeDate: [new Date((new Date().getFullYear()), 0, 1), new Date((new Date().getFullYear()), 11 + 1, 0)]
      }
    },
    mixins: [mixinMasters, mixinPermissions, MixinDatePicker],
    methods: {
      handleView (index, row) {
        this.isShow = true
        this.rowData = Object.assign({}, row)
        this.title = this.rowData.name
        this.modals['read'] = true
      },

      getFilteredData() {
        let self = this
        this.$emit('cotentLoading', true)

        let data = {}
        data.route ='billingsupports/index'
        data.filter_municipalities = (this.filter_municipalities.length == 0) ? '' : this.filter_municipalities.join()
        data.filter_departments = (this.filter_departments.length == 0) ? '' : this.filter_departments.join()
        data.init_date = moment(this.rangeDate[0]).format('YYYY-MM-DD')
        data.end_date = moment(this.rangeDate[1]).format('YYYY-MM-DD')

        this.saveMaster(data).then((response) => {
          this.tableData = response.data.billingSupports
          this.departments = response.data.departments
          this.municipalities = response.data.municipalities
          this.searchFuse(['Depart_Nombre', 'Region', 'Municipio_Nombre', 'IDPunto', 'NumeroDoc', 'Nombres', 'Depart_Code', 'Municipio_Code'])
          self.$emit('cotentLoading', false)
        }).catch((error) => {
          self.showMessageErrors(error)
          self.$emit('cotentLoading', false)
        })
      },

      handleSelectionChange(val) {
        if (val.length == 0) {
          this.multipleSelection = []
        }

        for (let index = 0; index < val.length; index++) {
          const element = val[index];
          if (!this.multipleSelection.includes(element.Cedula))
            this.multipleSelection.push(element.Cedula)
        }
      },

      dowloadSuports() {
        let next = false
        if (this.multipleSelection.length == 0) {
          showSwalAlert(
            'Iniciando descarga ...',
              0, false, 'Aceptar', 'Esta operación contiene ' + this.pagination.total + ' registros, lo que implica que su descarga tardara más tiempo de lo esperado. Estas seguro de continuar?', null, null
          ).then((result) => {
            if (result.value) {
              next = true
            }
          })
        } else {
          next = true
        }

        if (next) {
          let self = this
          showSwalAlert(
            'Espere mientras el o los archivos se descargan.',
              null, false, null, null, null, swal
          )

          return axios({
              url: '/auth/billingsupports/downloadsupports',
              data: {user: store.state.auth.user.id, multipleSelection : (self.multipleSelection.length == 0) ? '' : self.multipleSelection.join(), filter_municipalities: (self.filter_municipalities.length == 0) ? '' : self.filter_municipalities.join(), filter_departments: (self.filter_departments.length == 0) ? '' : self.filter_departments.join()},
              method: 'POST',
              responseType: 'blob',
          }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'Facturas.zip');
              document.body.appendChild(link);
              link.click();
              swal.close()
          }).catch((error) => self.showMessageErrors(error, 1))
        }
      }
    },

    created(){
      this.$emit('cotentLoading', true)
      if(this.canIndex()){
        this.getFilteredData()
      }
    },
  }
</script>
<style>
</style>
